export default "__VITE_ASSET__C5G6HpN2__"